import { GraphQLCampaign } from 'modules/campaigns/lib/types';

export const getActivateCampaignPayload = (campaign: GraphQLCampaign) => {
  const {
    id: campaignId,
    dataScienceOptimizations = [],
    customQuietHours,
    customRateLimit,
    schedulerMsgParams,
  } = campaign;

  return {
    campaignId,
    windowHours: schedulerMsgParams?.windowHours ?? null,
    dataScienceOptimizations: dataScienceOptimizations ?? [],
    customQuietHours: customQuietHours ?? null,
    customRateLimit: customRateLimit ?? null,
  };
};
